import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import { APPEARANCE_KEY, DEFAULT_COLORS, appearanceVariables, sanitizeColors } from "./colors";
import "./admin-theme.css";

const ThemeContext = createContext(null);
const readSavedColors = () => {
  try { return sanitizeColors(JSON.parse(window.localStorage.getItem(APPEARANCE_KEY))); }
  catch { return { ...DEFAULT_COLORS }; }
};
export function AdminThemeProvider({ children }) {
  const [colors, setColors] = useState(readSavedColors);
  const [saveError, setSaveError] = useState(false);
  const updateColors = useCallback((next) => {
    const safe = sanitizeColors(next);
    setColors(safe);
    try { window.localStorage.setItem(APPEARANCE_KEY, JSON.stringify(safe)); setSaveError(false); }
    catch { setSaveError(true); }
  }, []);
  useEffect(() => {
    const synchronize = (event) => {
      if (event.key === APPEARANCE_KEY || event.key === null) { setColors(readSavedColors()); setSaveError(false); }
    };
    window.addEventListener("storage", synchronize);
    return () => window.removeEventListener("storage", synchronize);
  }, []);
  const value = useMemo(() => ({ colors, updateColors, saveError }), [colors, updateColors, saveError]);
  const variables = useMemo(() => appearanceVariables(colors), [colors]);
  return <ThemeContext.Provider value={value}><div className="admin-theme-scope" style={variables}>{children}</div></ThemeContext.Provider>;
}
export function useAdminTheme() {
  const theme = useContext(ThemeContext);
  if (!theme) throw new Error("Personalisation must be used inside the admin appearance provider.");
  return theme;
}
export default function AdminThemeLayout() {
  return <AdminThemeProvider><Outlet /></AdminThemeProvider>;
}
